import React, { useState } from 'react';

import PropTypes from 'prop-types';
import Modal from '@tds/community-modal';
import Spinner from '@tds/core-spinner';

import request from '../../utils/request';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { Button } from './css';

const SendToSrt = ({ orderData, fetchOrders }) => {
  const { id, sendToSRT } = orderData;
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { confirmationDialog, sendToSrtLabel },
    formButtons: { confirmButtonLabel, cancelButtonLabel }
  } = localizedStrings;

  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSendToSrt = () => {
    const body = {
      sendToSRT: true
    };
    setIsLoading(true);
    request.put(`/orders/${id}`, body).then(() => {
      setIsLoading(false);
      fetchOrders();
    });
  };

  if (sendToSRT) return null;

  return (
    <>
      <Spinner
        fullScreen={isLoading}
        label="Requesting..."
        spinning={isLoading}
      />
      <Button onClick={() => setIsModalOpen(true)}>{sendToSrtLabel}</Button>
      <Modal
        heading={confirmationDialog}
        bodyText="Are you sure you want to send this order to SRT Group?"
        confirmCTAText={confirmButtonLabel}
        cancelCTAText={cancelButtonLabel}
        onConfirm={() => handleSendToSrt()}
        onClose={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
      />
    </>
  );
};

SendToSrt.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default SendToSrt;
